/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ColumnContainer } from 'components/grid/table/styled';
import { getPropsFromTypes } from 'utils/react';
import Header, {
  propTypes as HeaderPropTypes,
} from 'components/grid/table/components/column/components/header';
import { get, noop } from 'lodash';

class Column extends Component<any> {
  static propTypes = {
    Field: PropTypes.node.isRequired,
    data: PropTypes.array.isRequired,
    tableSearchable: PropTypes.bool.isRequired,
    withColumn: PropTypes.bool,
    zIndex: PropTypes.number,
    columnNumber: PropTypes.number,
    onRowClick: PropTypes.func,
    rowDisabled: PropTypes.func,
    title: PropTypes.string,
  };

  static defaultProps = {
    zIndex: undefined,
    columnNumber: undefined,
    onRowClick: noop,
    rowDisabled: noop,
    withColumn: false,
    title: undefined,
  };

  onRowClick = (...params) => () => {
    this.props.onRowClick(...params);
  };

  rowDisabled = (...params) => {
    if (this.props.rowDisabled !== noop) {
      return this.props.rowDisabled(...params);
    }
    return false;
  };

  getHeaderProps = () => {
    const { Field, ...props } = this.props;

    return getPropsFromTypes(
      {
        ...Field.props,
        ...props,
        sortKey: Field.props.sort,
      },
      // eslint-disable-next-line react/forbid-foreign-prop-types
      HeaderPropTypes,
    );
  };

  render() {
    const { data, Field, zIndex, columnNumber } = this.props;

    const headerProps = this.getHeaderProps();

    const name = Field.props.name;

    return (
      <ColumnContainer
        zIndex={zIndex}
        data-type="column"
        data-name={name}
        data-column-number={columnNumber}>
        {this.props.title && <Header {...headerProps} />}
        {data.map((data, rowNumber) => {
          return React.cloneElement(Field, {
            key: `${name}-${rowNumber}`,
            data,
            value: name ? get(data, name, '-') : null,
            className: `row-${rowNumber}`,
            rowDisabled: this.rowDisabled(data, rowNumber),
            onRowClick: this.onRowClick(data, rowNumber),
            rowNumber,
            columnNumber,
            zIndex: this.props.data.length - rowNumber,
          });
        })}
      </ColumnContainer>
    );
  }
}

export default Column;
